import React from "react";
import { STATUS_LABELS } from "health/healthStatusCopy";
import useHealthModule from "health/useHealthModule";
import readableHealthAlertTarget from "./readableTarget";
const HealthAlertEventDefinitionSummary = ({ config }) => {
  const { paths } = useHealthModule();
  if (!config) return null;
  const typedConfig = config;
  return /* @__PURE__ */ React.createElement("dl", null, /* @__PURE__ */ React.createElement("dt", null, "Health check"), /* @__PURE__ */ React.createElement("dd", null, typedConfig.targets.map((target) => readableHealthAlertTarget(target, paths)).join(", ")), /* @__PURE__ */ React.createElement("dt", null, "Alert when status becomes"), /* @__PURE__ */ React.createElement("dd", null, typedConfig.statuses.map((status) => STATUS_LABELS[status]).join(" or ")));
};
export default HealthAlertEventDefinitionSummary;
